export const ADD_PRODUCT = "cart/addProduct";
export const DELETE_PRODUCT = "cart/deleteProduct";

export const ADD_TO_CART = "cart/addToCart";
export const REMOVE_FROM_CART = "cart/removeFromCart";

export const INCREMENT_PRODUCT_COUNT = "cart/incrementProductCount";
export const DECREMENT_PRODUCT_COUNT = "cart/decrementProductCount";